//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  mounted() {
    const eventMethod = window.addEventListener ? "addEventListener"  : "attachEvent";
    const eventer = window[eventMethod];
    const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
    window.addEventListener(messageEvent, this.handleMessage)
  },
  beforeDestroy () {
    const eventMethod = window.addEventListener ? "addEventListener"  : "attachEvent";
    const eventer = window[eventMethod];
    const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
    window.removeEventListener(messageEvent, this.handleMessage)
  },
  methods: {
    handleMessage(e) {
      if (e.data === 'iframe_process_complete') {
         return;
      }
      try {
        const data = JSON.parse(e.data);
        const arr = data.redirectUrl.split('?')[1]
        const obj = arr.split('&').reduce((acc, n) => {
          const [ key, values ] = n.split('=');
          acc[key] = values;
          return acc;
        }, {})
        const { tretyakovId, mirId, hash, resultCode } = obj
        this.$axios({
          method: 'post',
          url: '/api/v1/personnel/saveLoyaltyData',
          data: `lang=${this.$i18n.locale || 'ru'}&userId=${tretyakovId}&loyaltyId=${mirId}&salt=wGyIf5t8rk5mz6lS&token=${hash}&resultCode=${resultCode}`
        })
          .then(({data}) => {
            window.location.href = `/app/profile/detail?mirStatus=${data.status}&error=${data.error ? data.error.message : ''}&data=${data.data}`
          })
          .catch(err => {
            // console.log('ERORRRR', err)
          })

      } catch (error) {
          // failed
          // console.log('error', error)
      }
    }
  },
  chimera: {
    getLoyaltyForm () {
      return {
        url: '/api/v1/personnel/getLoyaltyForm',
        key: 'getLoyaltyForm',
        auto: true,
        lang: this.$i18n.locale || 'ru'
      }
    }
  }
}
